<div class="body-padding">
  <div class="general-font text-4xl font-bold text-gray-900 dark:text-gray-100">Dashboard</div>
  <dashboard-charts/>

  <div class="mt-5 p-1" [class.hidden]="!hasPermission(Permission.ViewPMList)">
    <div class="special-font text-gray-900 dark:text-gray-100 text-2xl font-bold tracking-wide mb-4">Preventive Maintenance</div>

    <div [formGroup]="filterForm" class="flex flex-wrap gap-4 items-baseline align-baseline">
      <div class="w-fit mr-3">
        <label for="dashboard-search-input" class="block mb-2 text-sm font-medium text-gray-900 ">Search</label>
        <div id="dashboard-search-container"
             class="flex items-center h-[36px] border border-gray-300 dark:border-gray-600 rounded-md bg-gray-50 dark:bg-gray-700">
          <svg class="ml-2 h-5 w-5 pr-1 text-gray-600 dark:text-gray-300" width="15" height="16" viewBox="0 0 15 16" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <g id="Left Icon">
              <path id="Vector"
                    d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z"
                    stroke="currentColor"/>
            </g>
          </svg>
          <input id="dashboard-search-input" formControlName="search" type="text" placeholder="Assets Lookup"
                 class="input-custom h-full py-0"/>
        </div>
      </div>

      <div class="w-fit mr-3">
        <label for="dashboard-location-select" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-100">Location</label>
        <ng-select id="dashboard-location-select"
                   [items]="locations"
                   formControlName="location"
                   bindValue="location_id"
                   bindLabel="location_name"
                   placeholder="Location Lookup"
                   [clearable]="isSelectClearable('location')"
                   (clear)="clearSelectValue('location')"
                   notFoundText="No location found">
          <ng-template ng-label-tmp let-item="item">
            <p [id]="'dashboard-location-option-' + item.location_id || 'all'"
               [class.text-gray-500]="item.location_id === 0">
              {{ item.location_name }}
            </p>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div [id]="'dashboard-location-option-' + item.location_id || 'all'">
              <p>{{ item.location_name }}</p>
              @if (item.full_address) {
                <p class="opacity-50">{{ item.full_address }}</p>
              }
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <ul class="flex gap-2 flex-wrap mt-3 -mb-px text-lg font-medium text-center" id="default-tab" role="tablist">
      <li>
        <button id="past-due-tab" class="tab-button" [class.selected-tab-button]="activeTab() === 'past-due'"
                type="button" role="tab" aria-controls="past-due" (click)="changeTab('past-due')">
          Past Due
        </button>
      </li>
      <li>
        <button id="upcoming-tab" class="tab-button" [class.selected-tab-button]="activeTab() === 'upcoming'"
                type="button" role="tab" aria-controls="upcoming" (click)="changeTab('upcoming')">
          Upcoming
        </button>
      </li>
    </ul>

    @if (activeTab() === 'past-due') {
      <custom-table id="dashboard-past-due-table"
                    [columns]="tableColumns()"
                    [data]="pastDueTableData()"
                    primaryDataKey="asset_id"
                    [actions]="tableActions"
                    [serverPagination]="true"
                    [(currentPage)]="pastDueCurrentPage"
                    [loading]="loadingPastDueData()"
                    (paramsChange)="onPastDueTableParamChange($event)"
                    emptyDataMessage="No Past Due assets found"/>
    } @else {
      <custom-table id="dashboard-upcoming-table"
                    [columns]="tableColumns()"
                    [data]="upcomingTableData()"
                    primaryDataKey="asset_id"
                    [actions]="tableActions"
                    [serverPagination]="true"
                    [(currentPage)]="upcomingCurrentPage"
                    [loading]="loadingUpcomingData()"
                    (paramsChange)="onUpcomingTableParamChange($event)"
                    emptyDataMessage="No Upcoming assets found"/>
    }
  </div>
</div>

<ng-template #serialNumberColumn let-row>
  <div class="p-2">
    <span class="font-bold rounded"
          [ngClass]="row['is_active'] ? 'text-black dark:text-gray-100' : 'text-red-600 dark:text-red-400'">
      {{ row[DashboardTableColumn.SerialNumber] }}
    </span>
  </div>
</ng-template>

<ng-template #nextPmColumn let-row>
  <span class="whitespace-nowrap"
        [ngStyle]="{ 'color': row[DashboardTableColumn.NextPmStatusColor] }">
    {{ row[DashboardTableColumn.NextPm] }}
  </span>
</ng-template>
